import { render, staticRenderFns } from "./arreval.vue?vue&type=template&id=241f7d4e&scoped=true"
import script from "./arreval.vue?vue&type=script&lang=js"
export * from "./arreval.vue?vue&type=script&lang=js"
import style0 from "./arreval.vue?vue&type=style&index=0&id=241f7d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241f7d4e",
  null
  
)

export default component.exports